import React from 'react';
import { Colors } from '@client/style/Variables';
import FavouritesStore, { useIsFavourite } from './FavouriteStore';
import { useAuthenticatedUser } from '@client/utils/AuthStore';
import { OverlayController, Overlays } from '@client/core/modules/Overlays/Overlays';
import { OverlayLoginPrompt } from '../overlays/LoginPrompt/OverlayLoginPrompt';
import { styled } from 'styled-components';
import FavoriteStar from '@client/assets/svgs/favorite-star.svg';
import { PillButton } from '../shared/Buttons';

interface IProps {
	artistId: string;
}

const Star = styled(FavoriteStar)<{ $starColor?: string }>`
	color: ${props => props.$starColor ?? '#FF9900'};
	margin-left: -10px;
`;

export const FavouritePanel = (props: IProps) => {
	const isFavourite = useIsFavourite(props.artistId);
	const user = useAuthenticatedUser();

	return (
		<>
			{!isFavourite ? (
				<PillButton
					size='small'
					colors={{
						bg: Colors.darkBackground,
						fg: Colors.lightText,
					}}
					onClick={() => {
						if (!user) {
							Overlays.Instance.open({
								create: (controller: OverlayController) => {
									return <OverlayLoginPrompt controller={controller} />;
								},
							});
						}

						FavouritesStore.addFavourite({ id: props.artistId });
					}}
				>
					<Star $starColor={Colors.lightText + '22'} />
					<span>Tilføj favorit</span>
				</PillButton>
			) : (
				<PillButton
					size='small'
					colors={{
						bg: Colors.favouriteBackground,
						fg: Colors.lightText,
					}}
					onClick={() => {
						FavouritesStore.removeFavourite(props.artistId);
					}}
				>
					<Star $starColor={Colors.newsBackground} />
					<span>Fjern favorit</span>
				</PillButton>
			)}
		</>
	);
};
